import React from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@/blocks/Card';

import { useWindowLoaderData } from '../api/windowStore';
import { OrderTitle } from '../blocks/OrderTitle';
import { QuoteSummary } from '../blocks/QuoteSummary';
import configurationStyles from '../interfaces/configurations/Configurations.module.css';
import { CustomerPriceBlock } from '../interfaces/CustomerPriceBlock';
import { OrderSummary } from '../interfaces/OrderSummary';
import { QuoteSummaryAgentFooter } from '../interfaces/QuoteSummaryAgentFooter';
import { Label } from '../primitives/Label';
import { OrderLoaderType } from '../queries/order/loaders';

export const AgentOrderReview = () => {
  const order = useWindowLoaderData();

  return (
    <div style={{ padding: 'var(--block-padding) var(--inline-padding)' }}>
      <OrderTitle readonly />

      <section className="layout windowsLayout">
        <aside>
          <QuoteSummaryBlock order={order} />
          <CustomerPriceBlock order={order} readonly />
        </aside>
        <main>
          <ResellerInfo order={order} />
          <OrderSummary order={order} />
        </main>
      </section>
      <div
        style={{ paddingTop: 'calc(var(--footerHeight) + var(--space-l))' }}
      />
    </div>
  );
};

const ResellerInfo = ({ order }: { order: OrderLoaderType }) => {
  const { t } = useTranslation();
  const { userLead } = order;

  if (!userLead) return null;

  const fields = [
    { label: t('agent.resellerCompanyName'), value: userLead.companyName },
    { label: t('agent.resellerName'), value: userLead.name },
    { label: t('agent.resellerEmail'), value: userLead.email },
  ];

  return (
    <Card
      style={{
        backgroundColor: 'var(--gray-1)',
        borderRadius: 'var(--card-radius)',
        padding: 'var(--space-m)',
        marginBottom: 'var(--space-m)',
      }}
    >
      <p />
      <div className={configurationStyles.configurations}>
        <h3>{t('agent.customerTitle')}</h3>
        {fields.map(({ label, value }) => (
          <React.Fragment key={label}>
            <Label>{label}</Label>
            <span>{value || '-'}</span>
          </React.Fragment>
        ))}
      </div>
    </Card>
  );
};

const QuoteSummaryBlock = ({ order }: { order: OrderLoaderType }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 'var(--radius-s)',
        backgroundColor: 'var(--gray-1)',
      }}
    >
      <QuoteSummary order={order}>
        <QuoteSummaryAgentFooter order={order} />
      </QuoteSummary>
    </div>
  );
};
